const columnsData = [];

export default () => {
  const columnsContainers = document.querySelectorAll('.c-columns__items');

  if (columnsContainers.length < 1) {
    return;
  }

  [].forEach.call(columnsContainers, columnsContainer => {
    // eslint-disable-next-line prefer-spread
    const columnsHeaders = Array.apply(
      null,
      columnsContainer.querySelectorAll('.c-columns__media'),
    );

    if (columnsHeaders.length < 2) {
      return;
    }

    const chunks = Math.ceil(columnsHeaders.length / 3);
    const columnsChunks = [];

    for (let i = 0; i < chunks; i += 1) {
      columnsChunks.push(columnsHeaders.splice(0, 3));
    }

    columnsData.push(columnsChunks);
  });

  function measureHeaders() {
    const windowWidth = window.outerWidth;

    for (let i = 0; i < columnsData.length; i += 1) {
      const columnsChunks = columnsData[i];

      [].forEach.call(columnsChunks, columnsHeaders => {
        let maxHeight = 0;
        let minHeight = 0;

        [].forEach.call(columnsHeaders, header => {
          header.removeAttribute('style');

          if (windowWidth > 539) {
            maxHeight = Math.max(maxHeight, header.offsetHeight);
            minHeight =
              minHeight === 0
                ? header.offsetHeight
                : Math.min(minHeight, header.offsetHeight);
          }
        });

        if (maxHeight > 0 && minHeight !== maxHeight) {
          [].forEach.call(columnsHeaders, header => {
            header.style.height = `${maxHeight}px`; // eslint-disable-line no-param-reassign
          });
        }
      });
    }
  }

  measureHeaders();

  window.addEventListener('resize', measureHeaders);
  window.addEventListener('load', measureHeaders);
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/elefint-redesign-chisel/src/scripts/modules/columns.js